import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import MonitoringActionModalUI from './MonitoringActionModalUI'

class MonitoringActionModalSF extends Component {
  actionOptions = [
    { label: 'Select Action', value: 'Select Action' },
    { label: 'Penalty to be levied', value: 'Penalty to be levied' },
    { label: 'Due date extended', value: 'Due date extended' },
    { label: 'Penalty waived', value: 'Penalty waived' },
    { label: 'All complied', value: 'All complied' },
    { label: 'Intimation letter (Soft Letter)', value: 'Intimation letter (Soft Letter)' },
    { label: 'Waiver letter', value: 'Waiver letter' },
    { label: 'Notice of Non-compliance', value: 'Notice of Non-compliance' },
    { label: 'Notice of Acceleration/ Legal Notice', value: 'Notice of Acceleration/ Legal Notice' },
    { label: 'Filing of Criminal Complaint', value: 'Filing of Criminal Complaint' },
    { label: 'Follow up with client', value: 'Follow up with client' },
    { label: 'Court Hearing', value: 'Court Hearing' },
    { label: 'Other', value: 'Other' }
  ]

  commentOptions = [
    { label: 'Select Comment', value: 'Select Comment' },
    { label: 'Select Comment', value: 'Select Comment' },
    { label: 'DSRA Waiver', value: 'DSRA Waiver' },
    { label: 'EMI collected', value: 'EMI collected' }
  ]
  nonFinancialActionOptions = [
    { label: 'Select Action', value: 'Select Action' },
    { label: 'Penalty to be levied', value: 'Penalty to be levied' },
    { label: 'Due date extended', value: 'Due date extended' },
    { label: 'Penalty waived', value: 'Penalty waived' },
    { label: 'All complied', value: 'All complied' },
    { label: 'Intimation letter (Soft Letter)', value: 'Intimation letter (Soft Letter)' },
    { label: 'Waiver letter', value: 'Waiver letter' },
    { label: 'Notice of Non-compliance', value: 'Notice of Non-compliance' },
    { label: 'Notice of Acceleration/ Legal Notice', value: 'Notice of Acceleration/ Legal Notice' },
    { label: 'Filing of Criminal Complaint', value: 'Filing of Criminal Complaint' },
    { label: 'Follow up with client', value: 'Follow up with client' },
    { label: 'Court Hearing', value: 'Court Hearing' },
    { label: 'Other', value: 'Other' }
  ]

  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: [],
      selectedAction: '',
      actionError: null,
      selectedComment: '',
      commentError: null
    }
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    if (this.props.isUpdateMode && !prevProps.isUpdateMode) {
      const { currentItem } = this.props
      this.setState({
        selectedAction: (currentItem && currentItem.monitoringAction) || '',
        selectedComment: (currentItem && currentItem.monitoringComment) || '',
        successMsg: null,
        errorList: []
      })
    }
  }

  onActionChange = (event) => {
    this.setState({ selectedAction: event.target.value, actionError: null })
  }

  onCommentChange = (event) => {
    this.setState({ selectedComment: event.target.value, commentError: null })
  }

  validateForm = () => {
    let hasErrors = false
    const newErrorsObj = {}
    const newErrorsList = []

    if (!this.state.selectedAction || this.state.selectedAction === 'Select Action') {
      newErrorsObj.actionError = 'Please select a valid monitoring action'
      newErrorsList.push('Please select a valid monitoring action')
      hasErrors = true
    }

    if (this.state.selectedComment === 'Select Comment') {
      newErrorsObj.commentError = 'Please select a valid monitoring comment'
      newErrorsList.push('Please select a valid monitoring comment')
      hasErrors = true
    }

    this.setState({
      ...newErrorsObj,
      errorList: newErrorsList
    })

    return hasErrors
  }

  onSubmit = () => {
    if (this.validateForm()) {
      return
    }

    this.setState({
      successMsg: null,
      errorList: [],
    })

    const { currentItem } = this.props

    if (!currentItem || !currentItem.accountId) {
      this.setState({
        errorList: ['Invalid item selected for update']
      })
      return
    }

    let url = null
    const type = currentItem.reportType

    switch (type) {
      case "nachFailure":
      case "dsraShortfall":
        url = `/api/su/monitoringIntelligence/accounts/${currentItem.accountId}/reportType/${type}/addComment`
        break

      case "legalCharge":
      case "emi":
      case "penalCharge":
      case "chequeBounce":
        if (!currentItem.loanId) {
          this.setState({ errorList: ['Loan ID is missing for this report type'] })
          return
        }
        url = `/api/su/monitoringIntelligence/accounts/${currentItem.accountId}/loans/${currentItem.loanId}/reportType/${type}/addComment`
        break

      case "nonFinancial":
        if (!currentItem.loanId || !currentItem.legalLanguageCode) {
          this.setState({
            errorList: ['Loan ID or Legal Language Code missing for non-financial report type']
          })
          return
        }
        url = `/api/su/monitoringIntelligence/accounts/${currentItem.accountId}/loans/${currentItem.loanId}/nonCompliance/${currentItem.legalLanguageCode}/updateMonitoring`
        break

      // case "chequeBounce":
      //   if (!currentItem.loanId || !currentItem.chequeBounceId) {
      //     this.setState({ errorList: ['Loan ID or Cheque Bounce ID missing for this report type'] })
      //     return
      //   }
      //   url = `/api/su/monitoringIntelligence/loans/${currentItem.loanId}/reportType/${type}/chequeBounces/${currentItem.chequeBounceId}/addComment`
      //   break

      default:
        this.setState({
          errorList: [`Unsupported report type: ${type}`]
        })
        return
    }

    RestApiUtils.put(
      this.props.context,
      url,
      this.onSubmitCallback,
      {
        monitoringAction: this.state.selectedAction,
        monitoringComment: this.state.selectedComment
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    if (response.errorList) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
      })
    }

    this.setState({
      successMsg: response.success ? 'Monitoring information updated successfully' : null,
      errorList: errorList,
    })

    if (!response.errorList || response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null,
          selectedAction: '',
          actionError: null,
          selectedComment: '',
          commentError: null,
          errorList: []
        })
        this.props.onRefreshClick()
        this.props.onCancelClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }

  render() {
    return (
      <MonitoringActionModalUI
        context={this.props.context}
        isUpdateMode={this.props.isUpdateMode}
        onCancelClick={this.props.onCancelClick}
        onSubmit={this.onSubmit}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        setErrorList={this.setErrorList}
        selectedAction={this.state.selectedAction}
        onActionChange={this.onActionChange}
        actionError={this.state.actionError}
        selectedComment={this.state.selectedComment}
        onCommentChange={this.onCommentChange}
        commentError={this.state.commentError}
        currentItem={this.props.currentItem}
        // actionOptions={this.actionOptions}
        actionOptions={
          this.props.currentItem &&
            this.props.currentItem.reportType === "nonFinancial"
            ? this.nonFinancialActionOptions
            : this.actionOptions
        }

        commentOptions={this.commentOptions}
        showActionField={true}
        showCommentField={true}
      />
    )
  }
}

export default withRouter(MonitoringActionModalSF)
